import type { ReactNode } from 'react';
import cx from 'clsx';

interface SubtitleProps {
  children: ReactNode;
  className?: string;
}

export function Subtitle({ children, className }: SubtitleProps) {
  if (typeof children === 'string') {
    return (
      <p className={cx('body-standard', className)} data-testid="subtitle">
        {children}
      </p>
    );
  }

  return children;
}
